var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('async-multi-select',{attrs:{"value":_vm.value,"single":"","items":_vm.customers,"search":_vm.fetchCustomers,"label":"Гость — поиск по номеру телефона"},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }